import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchMeApi, sendOtpApi, updateProfileApi, verifyOtpApi } from "../../api/auth.api";

/* -------------------- SEND OTP -------------------- */

export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (mobile, { rejectWithValue }) => {
    try {
      const res = await sendOtpApi(mobile);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to send OTP",
      );
    }
  },
);

/* -------------------- VERIFY OTP -------------------- */

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ mobile, otp }, { rejectWithValue }) => {
    try {
      const res = await verifyOtpApi(mobile, otp);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Invalid OTP");
    }
  },
);

/* -------------------- UPDATE PROFILE -------------------- */

export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const res = await updateProfileApi(profileData);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update profile",
      );
    }
  },
);

/* -------------------- FETCH ME (BOOTSTRAP) -------------------- */

export const fetchMe = createAsyncThunk(
  "auth/fetchMe",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchMeApi();
      return res.data;
    } catch (err) {
      return rejectWithValue("Session expired");
    }
  }
);